import { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebase';
import AdminSidebar from '../../components/admin/AdminSidebar';
import AdminHeader from '../../components/admin/AdminHeader';
import ContactTable from '../../components/admin/ContactTable';
import Spinner from '../../components/Spinner';

export default function AdminContacts() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContacts();
  }, []);

  async function fetchContacts() {
    try {
      const contactsRef = collection(db, 'contactSubmissions');
      const q = query(contactsRef, orderBy('timestamp', 'desc'));
      const querySnap = await getDocs(q);
      
      const contactsList = [];
      querySnap.forEach((doc) => {
        contactsList.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      
      setContacts(contactsList);
    } catch (error) {
      console.error('Error fetching contacts:', error);
    } finally {
      setLoading(false);
    }
  }

  const unreadCount = contacts.filter((c) => !c.status || c.status === 'unread').length;

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="flex">
      <AdminSidebar />
      <div className="flex-1 ml-64">
        <AdminHeader title="Contact Form Submissions" />
        
        <div className="p-6">
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-gray-800">
              Total Submissions: {contacts.length}
            </h2>
            <p className="text-gray-600 mt-1">
              Unread: {unreadCount} • Read: {contacts.length - unreadCount}
            </p>
          </div>

          <ContactTable contacts={contacts} onUpdate={fetchContacts} />
        </div>
      </div>
    </div>
  );
}
